import { Inject, Injectable } from '@angular/core';
import {
  ApiService,
  AuthService,
  UtilService,
  LogService,
  HttpRequestService,
  EnvironmentService,
  NotificationService,
} from 'src/app/shared';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportServiceApiService extends ApiService {
  constructor(
    @Inject(AuthService) authService: AuthService,
    @Inject(UtilService) utilService: UtilService,
    @Inject(LogService) logService: LogService,
    @Inject(HttpRequestService) httpRequestService: HttpRequestService,
    @Inject(EnvironmentService) environmentService: EnvironmentService,
    @Inject(NotificationService) notificationService: NotificationService
  ) {
    super(authService, utilService, logService, httpRequestService, environmentService, notificationService);
    this.setBaseUrl('report');
  }

  public setBaseUrl(serviceName: string) {
    let apiBaseUrl: string = environment[`${serviceName}ServiceApiBase`];
    if (apiBaseUrl?.length) {
      let port = environment[`${serviceName}ServicePort`] ?? '';
      this._apiDomain = `${apiBaseUrl}${port}`;
      this._apiBaseUrl = `${this._apiDomain}/api`;
    }
  }
}
